// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import EditTournamentTeam from '../editTournamentTeam';
import { colors, btn, btnGroup, card, form } from '../../../../style/common/partnerStyle';


class AddTournamentTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      teams: [],
      groups: [],
      game_types: [],
      team_list :[],
      age_groups:[],
      tournament_team_details: {
        competition_id:props.match.params.id,
        id:'',
        name: this.props.match.params.team_name?this.props.match.params.team_name:'',
        group: '',
        game_type:'',
        logo:'',
        jersey:'',
        age_group:'',
        amount_paid:0,
        batch_id:''
      },
      team_name:'',
      team_id:'',
      addMemberView:false,
      data_uploaded: false,
      data_error: false,
      addNewTeamView:false,
      editTeamView:false,
      show_team_list:false,
      filtered_teams:[],
      selected_team:'',
      batch_team:false,
      venues:[],
      selected_venue:'',
      batches:[],
      filtered_venues:[],
      selected_venue_id:'',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileLogo = this.handleFileLogo.bind(this);
    this.handleFileJersey = this.handleFileJersey.bind(this);
    this.onClickVenue = this.onClickVenue.bind(this);
    this.handleBatchTeamCraetion = this.handleBatchTeamCraetion.bind(this);
    this.addTeam = this.addTeam.bind(this);
  }

  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamDetailInput();
  }

  getVenues() {
    var game_type = 'football-academy';
    const url = `${getLocationOrigin()}/venue_list/get_sporthood_locations/?game_type=${game_type}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ venues: data.venues, cities: data.cities }); })
      .catch(error => error);
  }

  getTeamDetailInput() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ teams: data.teams, groups: data.groups, age_groups: data.age_groups }); })
      .catch(error => error);
  }

  getaddTeamInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ game_types: data.game_types }); })
      .catch(error => error);
  }

  postaddTournamentTeam(data, props) {
    console.log('postaddTournamentTeam');
    if(data.group == '') { data.group = 'Group A'; }
    if(!this.state.batch_team && data.game_type == '') { data.game_type = this.state.game_types[0].pk; }
    if(!this.state.batch_team && data.age_group == '') { data.age_group = this.state.age_groups[0].id; }
    if(this.state.batch_team && data.batch_id == '') { alert("Please select a batch"); }
    else {
      console.log(data);
      const url = `${getLocationOrigin()}/eagleeye/create_tournament_team/`;
      const options = {...defaultOptions};
      var formData = new FormData();
      for(var name in data) { formData.append(name, data[name]); }
      options['method'] = 'post';
      options['body'] = formData;
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus).then(parseJSON)
        .then((response) => { alert(response.message); this.toBack(); })
        .catch(error => { console.log(error); alert(error.message); });
    }
  }

  handleChange(event) {
    const name = event.target.name;
    if(name == 'venue') {
      var venue_name = event.target.value;
      var filtered_venues = [];
      if(venue_name == '')
        filtered_venues = this.state.venues.slice(0, 10);
      else {
        filtered_venues = this.state.venues.filter(venue => (venue.name.toLowerCase().indexOf(venue_name.toLowerCase()) !== -1));
        if(filtered_venues && filtered_venues.length > 10)
          filtered_venues = filtered_venues.slice(0, 10);
      }
      this.setState({ selected_venue: venue_name, filtered_venues: filtered_venues });
    }
    else {
      console.log(event.target.name, event.target.value);
      var new_selected_one = Object.assign({}, this.state.tournament_team_details);
      new_selected_one[name] = event.target.value;
      this.setState({ tournament_team_details: new_selected_one });
    }
  }

  handleBatchTeamCraetion(event) {
    let checked = event.target.checked;
    if(checked) {
      this.setState({ batch_team: true }, () => {
        if(!this.state.venues.length > 0) this.getVenues();
      });
    }
    else { this.setState({ batch_team: false }); }
  }

  handleFileLogo(selectorFiles) {
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['logo'] = selectorFiles[0];
    this.setState({ tournament_team_details: new_selected_one });
  }

  toAddPlayerView(team) {
    console.log(team.team.id, team.team.name);
    this.setState({ team_name: team.team.name, team_id: team.team.id, addMemberView: !this.state.addMemberView });
  }

  handleFileJersey(selectorFiles) {
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['jersey'] = selectorFiles[0];
    this.setState({ tournament_team_details: new_selected_one });
  }

  handleSubmit(event) {
    event.preventDefault();
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    if(this.state.selected_team)
      new_selected_one['id'] = this.state.selected_team.id;
    this.postaddTournamentTeam(new_selected_one, this.props);
    console.log('post');
    console.log(this.state);
  }

  toBack() { this.props.history.goBack(); }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var j = 0; j < 6; j++) { color += letters[Math.floor(Math.random() * 16)]; }
    return color;
  }

  createImageFromInitials(size, name, color) {
    let initials;
    initials = name.substring(0, 1);
    name = initials.toUpperCase();
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = canvas.height = size;
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, size, size);
    context.fillStyle = `${color}50`;
    context.fillRect(0, 0, size, size);
    context.fillStyle = color;
    context.textBaseline = 'middle';
    context.textAlign = 'center';
    context.font = `${size / 2}px Roboto`;
    context.fillText(name, (size / 2), (size / 2));
    return canvas.toDataURL();
  }

  handleTeamChange(e) {
    const search = e.target.value.toLowerCase();
    var search_list = [];
    if(search == '') { search_list = this.state.teams; }
    else { search_list = this.state.teams.filter(item => (item.name.toLowerCase().indexOf(search) !== -1)); }
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    new_selected_one['name'] = e.target.value;
    this.setState({ filtered_teams: search_list, show_team_list: true, tournament_team_details: new_selected_one });
  }

  addTeam(team) {
    this.setState({ selected_team: team, show_team_list: false, search_field: false, filtered_teams: [] });
  }

  getBatches() {
    var game_type = 'football-academy';
    const url = `${getLocationOrigin()}/eagleeye/get_batches_for_team_creation/?game_type=${game_type}&venue_id=${this.state.selected_venue_id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ batches: data.result.fixture_details }); })
      .catch(error => error);
  }

  onClickVenue(venue) {
    this.setState({ selected_venue: venue.name, selected_venue_id: venue.id, batches: [], filtered_venues: [] }, () => { this.getBatches(); });
  }

  renderTeamdata() {
    return (
      <div>
        <div style={form.row}>
          <div style={form.labelWide}>Logo</div>
          <input type="file" style={{ ...form.input, padding: '7px 12px' }} name="logo" onChange={(e) => this.handleFileLogo(e.target.files)} />
        </div>
        <div style={form.row}>
          <div style={form.labelWide}>Jersey</div>
          <input type="file" style={{ ...form.input, padding: '7px 12px' }} name="jersey" onChange={(e) => this.handleFileJersey(e.target.files)} />
        </div>
        <div style={form.row}>
          <div style={form.labelWide}>Group / Zone</div>
          <input type="text" name="group" style={form.input} value={this.state.value} onChange={this.handleChange} />
        </div>
        <div style={form.row}>
          <div style={form.labelWide}>Amount Paid</div>
          <input type="number" name="amount_paid" style={form.input} className="required" value={this.state.value} onChange={this.handleChange} />
        </div>
      </div>
    );
  }

  renderCreateTournamentTeam() {
    return (
      <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

        <div style={form.row}>
          <div style={form.labelWide}>Team Name</div>
          {!this.state.selected_team ? (
            <div style={{ flex: 1, position: 'relative' }}>
              <input
                type="text"
                name="name"
                className="required"
                style={form.input}
                autoComplete="off"
                onChange={(e) => this.handleTeamChange(e)}
                value={this.state.tournament_team_details.name}
              />
              {this.state.filtered_teams.length > 0 && this.state.show_team_list && (
                <div style={{
                  position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
                  background: colors.surface, border: `1px solid ${colors.border}`,
                  borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                  maxHeight: 220, overflowY: 'auto', marginTop: 4,
                }}>
                  {this.state.filtered_teams.map(item => (
                    <div
                      key={item.id}
                      onClick={() => { this.addTeam(item); }}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        padding: '10px 14px', cursor: 'pointer', fontSize: 13, color: colors.text,
                        borderBottom: `1px solid ${colors.border}`,
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = colors.bg}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <img
                        style={{ width: 28, height: 28, borderRadius: 4, objectFit: 'cover' }}
                        src={item.logo && item.logo.includes('http') ? item.logo : this.createImageFromInitials(500, item.name, this.getRandomColor())}
                      />
                      <span>{item.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 12px', border: `1px solid ${colors.border}`,
              borderRadius: 8, background: colors.bg, flex: 1,
            }}>
              <img
                style={{ width: 28, height: 28, borderRadius: 4, objectFit: 'cover' }}
                src={this.state.selected_team.logo && this.state.selected_team.logo.includes('http') ? this.state.selected_team.logo : this.createImageFromInitials(500, this.state.selected_team.name, this.getRandomColor())}
              />
              <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: colors.text }}>{this.state.selected_team.name}</span>
              <button
                type="button"
                style={{ ...btn.dangerLt, padding: '3px 8px', fontSize: 11 }}
                onClick={() => { this.setState({ selected_team: '' }); }}
              >✕</button>
            </div>
          )}
        </div>

        {!this.state.selected_team && (
          <div>
            <div style={form.row}>
              <div style={form.labelWide}>Game Type</div>
              <select name="game_type" style={form.select} value={this.state.value} onChange={this.handleChange}>
                {this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + " : " + x.name}</option>
                ))}
              </select>
            </div>
            {this.renderTeamdata()}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
          <button type="button" style={btn.cancel} onClick={() => { this.toBack(); }}>Cancel</button>
          <button type="submit" style={btn.primary}>Submit</button>
        </div>

      </form>
    );
  }

  renderCreateBatchteam() {
    return (
      <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

        <div style={form.row}>
          <div style={form.labelWide}>Venue</div>
          <div style={{ flex: 1, position: 'relative' }}>
            <input
              autoComplete="off"
              type="text"
              name="venue"
              style={form.input}
              value={this.state.selected_venue}
              onChange={this.handleChange}
            />
            {this.state.filtered_venues.length > 0 && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
                background: colors.surface, border: `1px solid ${colors.border}`,
                borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                maxHeight: 220, overflowY: 'auto', marginTop: 4,
              }}>
                {this.state.filtered_venues.map((venue, index) => (
                  <div
                    key={index}
                    onClick={() => { this.onClickVenue(venue); }}
                    style={{
                      padding: '10px 14px', cursor: 'pointer', fontSize: 13, color: colors.text,
                      borderBottom: `1px solid ${colors.border}`,
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = colors.bg}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    {venue.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div style={form.row}>
          <div style={form.labelWide}>Batch</div>
          <select name="batch_id" style={form.select} value={this.state.value} onChange={this.handleChange}>
            <option value=''>------------</option>
            {this.state.batches.length > 0 && this.state.batches.map((batch, index) => (
              <option key={index} value={batch.id}>{batch.squad_name ? batch.squad_name : batch.name}</option>
            ))}
          </select>
        </div>

        {this.renderTeamdata()}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
          <button type="button" style={btn.cancel} onClick={() => { this.toBack(); }}>Cancel</button>
          <button type="submit" style={btn.primary}>Submit</button>
        </div>

      </form>
    );
  }

  render() {
    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, minHeight: '100vh', padding: '24px 20px', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: `1px solid ${colors.border}` }}>
              <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Add New Team</h2>
            </div>

            <div style={{ padding: '20px 24px' }}>

              {/* Batch selection toggle */}
              <div style={{ ...form.row, marginBottom: 20 }}>
                <div style={form.labelWide}>Batch Selection</div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: colors.text }}>
                  <input
                    type="checkbox"
                    onChange={this.handleBatchTeamCraetion}
                    style={{ width: 16, height: 16, cursor: 'pointer', accentColor: colors.brand }}
                  />
                  <span>Create team from existing batch</span>
                </label>
              </div>

              {this.state.batch_team ? this.renderCreateBatchteam() : this.renderCreateTournamentTeam()}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddTournamentTeam;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeam/index.js